import React from 'react';
import PropTypes from 'prop-types';

export const Plug = ({ title }) => (
  <div className='text-center my-5 py-5'>{title}</div>
);

Plug.propTypes = {
  title: PropTypes.string.isRequired,
};


// WEBPACK FOOTER //
// src/components/shared/Plug/Plug.jsx